// Utility to create enums with toString and parse methods
function createEnum(values) {
    const enumObject = {};

    // Assign values and formatted names
    Object.keys(values).forEach(key => {
        enumObject[key] = values[key];
    });

    // Add toString method
    enumObject.toString = function (value) {
        const name = Object.keys(values).find(key => values[key] === value);
        let outputName = name ? name.replace(/([A-Z])/g, " $1").trim() : "Unknown";
        
        if(outputName === "i O S") {
            outputName = "iOS";
        }
        
        return outputName;
    };

    // Add parse method
    enumObject.parse = function (name) {
        const key = Object.keys(values).find(
            key => key.toLowerCase() === name.toLowerCase()
        );
        return key !== undefined ? values[key] : null;
    };

    enumObject.toSelect = function (){
        const keys = Object.keys(values);
        
        return keys.map(key => {
            return {value: values[key], label: key};
        })
    }
    
    return enumObject;
}

// Define enums
export const Platforms = createEnum({
    iOS: 0,
    Android: 1,
    Web: 2
});